// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 511 ? "component---src-core-pages-page-template-tsx" : chunkId) + "-" + {"511":"06789600cfff8db2f34f","559":"d1b3ddb08cb42ab55288"}[chunkId] + ".js";
};